export default {
  Classroom: {
    HaventJoinedClassYet:
      'Bạn chưa tham gia lớp học nào. Hãy liên hệ với giáo viên phụ trách để nhận mã lớp và bắt đầu học tập.',
    JoinClass: 'Tham gia lớp học',
    AwaitingApproval: 'Đang chờ phê duyệt ({entityName})',
    PleaseContactYourTeacher:
      'Hãy liên hệ giáo viên của bạn để lấy mã lớp và bắt đầu sử dụng nhé!',
    CheckClassInformation:
      'Hãy kiểm tra thông tin cơ bản về lớp học để chắc chắn rằng bạn tìm thấy đúng lớp của mình nhé!',
    ClassInformation: 'Thông tin lớp học',
    NotTheClassWantToJoin: 'Không phải lớp bạn muốn tham gia?',
    JoinClassSuccess: 'Tham gia lớp học thành công',
    WaitForApproval: 'Chờ phê duyệt từ giáo viên',
    DescriptionApproval:
      'Lớp học bạn đăng ký cần sự phê duyệt của giáo viên phụ trách để tham gia.',
    GetTheClassCodeBack: 'Nhập lại mã lớp',
    JoinOtherClass: 'Tham gia thêm lớp học khác',
    LeaveClass: 'Rời lớp học',
    ClassJoinng: 'Lớp học đang tham gia',
    ClassName: 'Tên lớp',
    TeacherName: 'Giáo viên',
    OrganizationName: 'Trường',
    GradeName: 'Khối',
    Subject: 'Môn học',
    Description: 'Mô tả',
    AreYouSureQuit: 'Bạn có chắc muốn rời lớp',
    No: 'Không',
    LeftClass: 'Đã rời lớp học',
    DeleteClassFail: 'Rời lớp học thất bại',
    ClassWaitAppro: 'Lớp học đang chờ phê duyệt',
    CancelWaitAppr: 'Hủy yêu cầu',
    ClassInActive: 'Lớp học không còn hoạt động',
    Friendly: 'Bạn học',
    PutClassCodeAgain: 'Nhập lại mã lớp',
    PartnerExercise: 'Bài tập tham khảo',
    StorageExercise: 'Học liệu tham khảo',

    // Theme
    SuggestThemeAfterFirstTimeJoinClass: 'Hệ thống gợi ý cho bạn sử dụng giao diện vui nhộn, bạn có muốn áp dụng giao diện không?',
    TextLoadingTheme: 'Đang đổi sang giao diện mới, bạn vui lòng chờ<br/>trong giây lát...',
    RequestJoinClassSuccess: 'Lớp đang chờ phê duyệt',
    DescriptionJoinClassSuccess: 'Chào mừng bạn tham gia lớp học đầu tiên.<br/>Chúc bạn có trải nghiệm học tập tốt với giao diện mới!',

    // Nvduc
    ClassroomList: 'Danh sách lớp học',
    ExerciseList: 'DS bài tập',
    WelcomeJoinClass: 'Chào mừng bạn đã tham gia lớp ',

    ChoseSubject: 'Chọn môn học'
  }
}
